module.exports = __webpack_public_path__ + "resources/430ae0156ba024b4736e61823583fa47.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/oversizedcrisisvillain.png
// module id = 218
// module chunks = 0